/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import '@/quote-management/components/OrderSummaryLine/OrderSummaryLine.css';
import { classes, VComponent } from '@adobe-commerce/elsie/lib';
import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
export interface OrderSummaryLineComponentProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'label'> {
  label: VNode | string;
  price: VNode<HTMLAttributes<HTMLSpanElement>>;
  classSuffixes?: Array<string>;
  labelClassSuffix?: string;
  testId?: string;
  children?: any;
}

export const OrderSummaryLine: FunctionComponent<
  OrderSummaryLineComponentProps
> = ({
  label,
  price,
  classSuffixes = [],
  labelClassSuffix,
  testId,
  children,
  ...props
}) => {
  const labelClass = 'quote-order-summary__label';
  const priceClass = 'quote-order-summary__price';
  return (
    <div
      {...props}
      {...(testId ? { 'data-testid': testId } : {})}
      className={classes([
        'quote-order-summary__entry',
        ...classSuffixes.map(
          (classSuffix) => `quote-order-summary__${classSuffix}`
        ),
      ])}
    >
      <span
        className={classes([
          labelClass,
          ...(labelClassSuffix ? [`${labelClass}--${labelClassSuffix}`] : []),
        ])}
      >
        {label}
      </span>

      <VComponent
        node={price}
        className={classes([
          priceClass,
          ...(labelClassSuffix ? [`${priceClass}--${labelClassSuffix}`] : []),
        ])}
      />

      {children}
    </div>
  );
};
